import React, { FC, useContext, useState, ReactNode } from 'react';

export type EditContextType = {
  editingId: string | null;
  changeEditingId(id: string | null): void;
};

export const EditContext = React.createContext<EditContextType>({
  editingId: null,
  changeEditingId: () => {},
});

export const useEdit = () => useContext(EditContext);

export const EditProvider: FC<{
  children: (ctx: EditContextType) => ReactNode;
}> = ({ children }) => {
  const [editingId, changeEditingId] = useState<string | null>(null);
  return (
    <EditContext.Provider value={{ editingId, changeEditingId }}>
      {children({ editingId, changeEditingId })}
    </EditContext.Provider>
  );
};
